<template>
    <div>
        <div>
            <label
                class="mb-1 block text-sm font-medium"
                for="name"
                >{{ $t('file') }} <span class="text-danger-500">*</span></label
            >
        </div>
        <div class="mb-2 flex flex-row gap-2">
            <button
                class="btn bg-primary-additional-500 hover:bg-primary-additional-600 text-white"
                @click.prevent="openFileDialog"
            >
                {{ $t('choose_file') }}
            </button>
            <button
                class="btn border-gray-200 text-gray-600 hover:border-gray-300"
                @click="resetForm"
            >
                {{ $t('reset') }}
            </button>
        </div>
        <div>
            <input
                v-if="fileName"
                v-model="fileName"
                class="form-input w-full bg-gray-200"
                type="text"
                disabled
            />
        </div>
    </div>
    <div>
        <TextField
            v-model="modelValue.name"
            name="name"
            label="name"
            help="help_file_name"
            :required="true"
        />
    </div>
    <div>
        <SelectField
            v-model="modelValue.language"
            name="language"
            label="language"
            :options="Object.values(languages)"
            :required="true"
        />
    </div>
</template>
<script setup lang="ts">
import { SelectField, TextField } from '@src/components'
import { SelfDisclosureForm } from '@src/types'
import { useLanguageStore } from '@src/utils/stores/languages'
import { useFileDialog } from '@vueuse/core'
import { storeToRefs } from 'pinia'
import { Ref, ref, toRefs, watch } from 'vue'

const props = defineProps<{
    modelValue: Ref<SelfDisclosureForm>
}>()

const { modelValue } = toRefs(props)
const emit = defineEmits(['update:modelValue'])

const {
    files,
    open: openFileDialogReal,
    reset,
} = useFileDialog({ multiple: false, accept: '.pdf' })
const fileName = ref<string | null>(null)

const languageStore = useLanguageStore()
const { languages } = storeToRefs(languageStore)

function openFileDialog(): void {
    openFileDialogReal()
}

function resetForm(): void {
    reset()
    modelValue.value = new SelfDisclosureForm()
}

watch(files, (files) => {
    fileName.value = files?.item(0)?.name ?? null
    modelValue.value.name = files?.item(0)?.name ?? null
})

watch(modelValue.value, (value) => {
    emit('update:modelValue', value, files)
})
</script>
